//BASE URL
export const BASE_URL = 'https://api.avnain.com';

//BLOG URL
export const GET_BLOG = '/api/v1/Blog/featchall'
export const GET_BLOG_BY_ID = '/api/v1/Blog/getblogbyuuid'


// product URL
export const GET_PRODUCT = '/api/v1/product/featchall'
export const GET_PRODUCT_BY_ID = '/api/v1/product/getproductbyproducttype/'

//product type
export const GET_PRODUCT_TYPE = '/api/v1/type/featchall'

// contact URl
export const POST_Contact = "/api/v1/contact/createcontact";

// contactlist URL
export const GET_CONTACTLIST = "/api/v1/contactlist/featchall";
